import { SocialAssetDataSource } from './enum/social-asset-data-source';
import { SocialMediaEventType } from './enum/social-media-event-type';

const SocialMediaEventTypeToDataSourceMappings = {
  [SocialMediaEventType.Transaction]: SocialAssetDataSource.SalesSoldListing,
  [SocialMediaEventType.Listing]: SocialAssetDataSource.SalesNewListing,
  [SocialMediaEventType.Review]: SocialAssetDataSource.SaleReview,
  [SocialMediaEventType.MortgageBrokerReview]: SocialAssetDataSource.MortgageBrokingReview,
  [SocialMediaEventType.LeasingReview]: SocialAssetDataSource.LeasingReview,
  [SocialMediaEventType.LeasingListing]: SocialAssetDataSource.LeasingNewListing,
  [SocialMediaEventType.LeasingTransaction]: SocialAssetDataSource.LeasingLeasedListing,
  [SocialMediaEventType.Award]: SocialAssetDataSource.Awards,
};

export function EventTypeToDataSource(eventType: SocialMediaEventType): SocialAssetDataSource {
  return SocialMediaEventTypeToDataSourceMappings[eventType];
}
